import React, { useState } from "react";
import Card from "components/card";
import { MdClose } from "react-icons/md";
import { FaPassport } from "react-icons/fa";

const VisaModal = ({ isOpen, onClose, onAdd, editingItem }) => {
  const [formData, setFormData] = useState({
    name: "",
    type: "",
    processing: "",
    price: "",
    applicationDate: ""
  });

  React.useEffect(() => {
    if (editingItem) {
      setFormData({
        name: editingItem.name || "",
        type: editingItem.type || "",
        processing: editingItem.processing || "",
        price: editingItem.price || "",
        applicationDate: editingItem.applicationDate || ""
      });
    } else {
      setFormData({ name: "", type: "", processing: "", price: "", applicationDate: "" });
    }
  }, [editingItem, isOpen]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onAdd(formData);
    setFormData({ name: "", type: "", processing: "", price: "", applicationDate: "" });
    onClose();
    
    // Trigger auto-save by dispatching custom event
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('cartesUpdated'));
    }, 600);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
      <Card extra="w-[500px] max-h-[90vh] overflow-y-auto">
        <div className="bg-gradient-to-r from-red-500 to-red-600 p-6 rounded-t-[20px]">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="rounded-full bg-white p-2">
                <FaPassport className="h-6 w-6 text-red-500" />
              </div>
              <h3 className="text-2xl font-bold text-white">{editingItem ? 'Edit Visa Service' : 'Add Visa Service'}</h3>
            </div>
            <button onClick={onClose} className="rounded-full bg-white/20 p-2 text-white hover:bg-white/30">
              <MdClose className="h-6 w-6" />
            </button>
          </div>
        </div>
        
        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-semibold text-navy-700 dark:text-white mb-2">Visa Service Name</label>
              <input
                type="text"
                placeholder="e.g., Tourist Visa - USA"
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                className="w-full rounded-xl border-2 border-gray-200 p-3 focus:border-red-500 focus:outline-none dark:border-gray-600 dark:bg-navy-800 dark:text-white transition-colors"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-semibold text-navy-700 dark:text-white mb-2">Visa Type</label>
              <select
                value={formData.type}
                onChange={(e) => setFormData({...formData, type: e.target.value})}
                className="w-full rounded-xl border-2 border-gray-200 p-3 focus:border-red-500 focus:outline-none dark:border-gray-600 dark:bg-navy-800 dark:text-white transition-colors"
                required
              >
                <option value="">Select Visa Type</option>
                <option value="B1/B2 Visa">B1/B2 Tourist/Business</option>
                <option value="Tier 2 Visa">Tier 2 Work Visa</option>
                <option value="Transit Visa">Transit Visa</option>
                <option value="Student Visa">Student Visa</option>
                <option value="Work Permit">Work Permit</option>
              </select>
            </div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-semibold text-navy-700 dark:text-white mb-2">Application Date</label>
              <input
                type="date"
                value={formData.applicationDate}
                onChange={(e) => setFormData({...formData, applicationDate: e.target.value})}
                className="w-full rounded-xl border-2 border-gray-200 p-3 focus:border-red-500 focus:outline-none dark:border-gray-600 dark:bg-navy-800 dark:text-white transition-colors"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-semibold text-navy-700 dark:text-white mb-2">Processing Time</label>
              <select
                value={formData.processing}
                onChange={(e) => setFormData({...formData, processing: e.target.value})}
                className="w-full rounded-xl border-2 border-gray-200 p-3 focus:border-red-500 focus:outline-none dark:border-gray-600 dark:bg-navy-800 dark:text-white transition-colors"
                required
              >
                <option value="">Select Processing Time</option>
                <option value="1-3 Days">1-3 Days (Express)</option>
                <option value="3-5 Days">3-5 Days (Standard)</option>
                <option value="5-7 Days">5-7 Days (Regular)</option>
                <option value="10-15 Days">10-15 Days (Normal)</option>
                <option value="15-30 Days">15-30 Days (Economy)</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-semibold text-navy-700 dark:text-white mb-2">Service Fee</label>
              <input
                type="text"
                placeholder="e.g., $299"
                value={formData.price}
                onChange={(e) => setFormData({...formData, price: e.target.value})}
                className="w-full rounded-xl border-2 border-gray-200 p-3 focus:border-red-500 focus:outline-none dark:border-gray-600 dark:bg-navy-800 dark:text-white transition-colors"
                required
              />
            </div>
          </div>
          
          <div className="flex space-x-4 pt-4">
            <button
              type="submit"
              className="flex-1 rounded-xl bg-gradient-to-r from-red-500 to-red-600 py-3 px-6 text-white font-semibold hover:from-red-600 hover:to-red-700 transform hover:scale-105 transition-all duration-200 shadow-lg"
            >
{editingItem ? 'Update Visa Service' : 'Add Visa Service'}
            </button>
            <button
              type="button"
              onClick={onClose}
              className="flex-1 rounded-xl bg-gray-100 py-3 px-6 text-gray-700 font-semibold hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600 transition-colors"
            >
              Cancel
            </button>
          </div>
        </form>
      </Card>
    </div>
  );
};

export default VisaModal;